(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dmg-custom-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmg-custom-purchase')) {
    customElements.define('dmg-custom-purchase', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.onOptionsChanged = (event) => {
          if (event.target.closest('variant-selects')) this.updateEmail();
        };
        this.productInfo?.addEventListener('change', this.onOptionsChanged);
      }
      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onOptionsChanged);
      }
      updateEmail() {
        const picker = this.productInfo?.querySelector('variant-selects');
        if (!picker) return;
        const selected = [...picker.querySelectorAll('input:checked, select option:checked')].map((option) => option.value.trim());
        if (!selected.length) return;
        const body = `${this.dataset.productLabel}: ${this.dataset.productTitle}\n${this.dataset.variantLabel}: ${selected.join(' / ')}`;
        this.querySelector('.dmg-custom-purchase__email').href = `mailto:contact@daodeca.com?subject=${encodeURIComponent(this.dataset.subject)}&body=${encodeURIComponent(body)}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dmg-mobile-localization"] && !Shopify.designMode) return;
  try {
    function setupMobileLocale() {
  const dialog = document.getElementById('DmgLocaleDialog');
  if (!dialog) return;
  document.querySelectorAll('.dmg-locale-open').forEach(button => {
    if (button.dataset.localeBound) return;
    button.dataset.localeBound = 'true';
    button.addEventListener('click', () => dialog.showModal());
  });
  if (dialog.dataset.localeBound) return;
  dialog.dataset.localeBound = 'true';
  dialog.querySelector('.dmg-locale-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientY < box.top || event.clientX < box.left || event.clientX > box.right) dialog.close();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupMobileLocale); else setupMobileLocale();
document.addEventListener('shopify:section:load', setupMobileLocale);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dmg-shipping-lookup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmg-shipping-regions')) {
    customElements.define('dmg-shipping-regions', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const select = this.querySelector('[data-region-select]');
        const fallback = this.querySelector('[data-fallback]');
        const rows = Array.from(this.querySelectorAll('tbody tr[data-regions]'));
        if (!select || !fallback || !rows.length) return;
        const render = () => {
          const region = select.value;
          const row = rows.find(item => item.dataset.regions.split(' ').includes(region));
          this.querySelector('[data-prompt]').hidden = !!region;
          this.querySelector('[data-result]').hidden = !row;
          this.querySelector('[data-unlisted]').hidden = !region || !!row;
          const name = this.querySelector('[data-result-region]');
          const fee = this.querySelector('[data-result-fee]');
          const time = this.querySelector('[data-result-time]');
          name.textContent = row ? select.selectedOptions[0].textContent : '';
          fee.replaceChildren();
          time.replaceChildren();
          if (row) {
            fee.append(...row.cells[1].cloneNode(true).childNodes);
            time.append(...row.cells[2].cloneNode(true).childNodes);
          }
        };
        select.addEventListener('change', render);
        render();
        fallback.hidden = true;
        this.querySelector('[data-query]').hidden = false;
        this.dataset.ready = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
